package com.tregz.tremenz.io.audio

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberAudioRouter(): AudioRouter = remember { AudioRouterBrowser }

/**
 * Browsers pick the output device themselves — there is no equivalent of Android's communication
 * device picker — so the list stays empty and the UI hides the chooser.
 */
private object AudioRouterBrowser : AudioRouter {

    override fun outputs(): List<AudioOutput> = emptyList()

    override fun select(output: AudioOutput) = Unit
}
